<app-page-container class="elevate-billing-container" [layoutType]="LayoutType.IntegratedTab" [tabConfig]="tabConfig"
    [title]="title">
</app-page-container>
